import React from 'react';
import { Icon, Spinner } from 'ui';
import FilteredRequest from '../_shared/FilteredRequest';
import CriterionRow from '../_shared/CriterionRow';
import DataCard from '../_shared/DataCard';

const ratingOptions = [
  { score: 1 },
  { score: 2 },
  { score: 3 },
  { score: 4 },
  { score: 5 },
];

const newIcons = [
  'rating-warn',
  'rating-wrench',
  'rating-check',
  'rating-thumbs-up',
  'rating-trophy',
];
const defaultScores = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 };

const modifyCriterion = criterion => ({
  ...criterion,
  data: {
    average: criterion.average,
    total: criterion.total,
    countPerStarRating: criterion.count_per_star_rating.reduce(
      (acc, count) => ({
        ...acc,
        [count.score]: count.frequency,
      }),
      defaultScores,
    ),
  },
});

const CriteriaList = ({ criteria }) => (
  <>
    {criteria.map(criterion => {
      const modifiedCriterion = modifyCriterion(criterion);
      return (
        <CriterionRow
          criterion={modifiedCriterion}
          key={modifiedCriterion.name}
          ratingOptions={ratingOptions}
        />
      );
    })}
  </>
);

const CriteriaHeader = () => {
  return newIcons.map(iconName => (
    <span key={iconName}>
      <Icon name={iconName} />
    </span>
  ));
};

const CriteriaRatingsTable = ({ url, title, subtitle }) => (
  <FilteredRequest url={url}>
    {({ data, loading }) => (
      <DataCard.Content title={title} subtitle={subtitle}>
        <div className="FeedbackCriteriaInsights mw-700">
          <table>
            <thead>
              <tr className="FeedbackCriteriaInsights-headerRow fw-b">
                <th className="FeedbackCriteriaInsights-headerRow--newCriteria">
                  {t('insights.criterion.headers.criteria')}
                </th>
                <th>{t('insights.criterion.headers.total_ratings')}</th>
                <th className="FeedbackCriteriaInsights-headerRow--ratingScale">
                  <CriteriaHeader />
                </th>
              </tr>
            </thead>
            <tbody className="fz-bigger">
              {loading && (
                <tr>
                  <Spinner />
                </tr>
              )}
              {!loading && data && data.length === 0 && (
                <tr className="p-4">
                  <th>{t('insights.criterion.no_results')}</th>
                </tr>
              )}
              {!loading && data && data.length > 0 && (
                <CriteriaList criteria={data} />
              )}
            </tbody>
          </table>
        </div>
      </DataCard.Content>
    )}
  </FilteredRequest>
);

export default CriteriaRatingsTable;
